import { __rest, __assign } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { SelectLegacy } from '../SelectLegacy.js';
import '@compono/ui-icons';
import '@emotion/react/jsx-runtime';
import '../../Button/Button.js';
import '../../Button/ButtonBase/index.js';
import '../../Button/ButtonBody/index.js';
import '../../Dropdown/DropdownProvider.js';
import '../SelectLegacyProvider.js';
import '../../Box/index.js';
import '../SelectLegacyDropdown.js';
import '../SelectLegacyDropdownOption.js';
import '../../Selectable/SelectableOptions.js';
import '../../Selectable/SelectableProvider.js';
import '@emotion/react';
import 'lodash.get';
import '@compono/ui-theme';
import 'deepmerge';
import '@emotion/is-prop-valid';
import 'react';
import 'crypto-js/md5';
import 'assert';
import 'react-keyed-flatten-children';
import '../../Tag/TagIcon.js';
import '../../Tag/TagLabel.js';
import '../../Selectable/Selectable.js';
import 'cuid';
import '../../hooks/useDetectInputMethod.js';
import '@reach/auto-id';
import '@xstate/react';
import '../../Selectable/stateMachine/stateMachine.js';
import '../../Selectable/stateMachine/actionsMultiple.js';
import '../../Selectable/stateMachine/actionsSelectActive.js';
import '../SelectLegacySection.js';

/**
 * Select Multi Level
 */
var MultiLevelSelectLegacy = function (props) {
    var options = props.options, onChange = props.onChange, children = props.children, forwardProps = __rest(props, ["options", "onChange", "children"]);
    return (jsx(SelectLegacy, __assign({ options: options, onChange: onChange }, forwardProps, { children: children })));
};
MultiLevelSelectLegacy.displayName = "MultiLevelSelectLegacy";

export { MultiLevelSelectLegacy };
//# sourceMappingURL=MultiLevelSelectLegacy.js.map
